export default __webpack_public_path__ + "static/media/expl-gradcam_10_EN.98420ec4.png";